import { QueryString } from "./query-string";

export default function isDebug(): boolean {
  return QueryString.get("identity_debug") === "1";
}
